export default __webpack_public_path__ + "static/media/studentsCard.1878b059.svg";